const CREATE_CABINETS = 'ClinicPanelCabinetList';
const CREATE_EMPLOYEES = 'ClinicPanelEmployeeList';
const FILL_WORK_SCHEDULE = 'ClinicPanelWorkSchedule';
const FILL_PRICE = 'ClinicPanelServicePriceList';
const GENERAL_SETTINGS = 'ClinicPanelSettings';

/**
 * @description Получить доступные шаги.
 * @param availableSteps
 * @returns {Array}
 */
const getSteps = (availableSteps) => [
  {
    isPassed: availableSteps.includes('general-settings'),
    title: 'Общие настройки',
    to: GENERAL_SETTINGS,
  },
  {
    isPassed: availableSteps.includes('create-cabinets'),
    title: 'Кресла',
    to: CREATE_CABINETS,
  },
  {
    isPassed: availableSteps.includes('create-employees'),
    title: 'Сотрудники',
    to: CREATE_EMPLOYEES,
  },
  {
    isPassed: availableSteps.includes('fill-work-schedule'),
    title: 'График',
    to: FILL_WORK_SCHEDULE,
  },
  {
    isPassed: availableSteps.includes('fill-price'),
    title: 'Прайс',
    to: FILL_PRICE,
  },
].flatMap(({ isPassed, title, to }) => {
  if (isPassed) {
    return [{ title, to }];
  }
  return [];
});

/**
 * @description Примесь пошаговой инструкции.
 * @type {Vue}
 */
export default {
  computed: {
    /**
     * @description Доступные шаги.
     * @returns {Array}
     */
    availableInstructionSteps() {
      return getSteps(this.instructionSteps);
    },
    /**
     * @description Индекс текущего шага.
     * @returns {number}
     */
    currentStepIndex() {
      return this.availableInstructionSteps.findIndex((step) => step.to === this.$route.name);
    },
  },
  created() {
    this.fetchInstructionSteps();
  },
  data() {
    return {
      /**
       * @description Шаги инструкции.
       * @type {string[]}
       */
      instructionSteps: [],
    };
  },
  methods: {
    /**
     * @description Навигация до предыдущего шага.
     * @returns {Object}
     */
    backStepNavigation() {
      const step = this.availableInstructionSteps[this.currentStepIndex - 1] ?? {};
      return {
        name: step.to,
        params: { initialAvailableSteps: this.availableSteps },
      };
    },
    /**
     * @description Затянуть шаги инструкции.
     * @returns {void}
     */
    fetchInstructionSteps() {
      const onResponse = (steps) => {
        this.instructionSteps = steps;
      };
      this
        .$settingGateway
        .viewInstructionSteps()
        .then((result) => result.forEach(onResponse));
    },
  },
};
